import e from "dayjs";
import t from "dayjs/plugin/isSameOrAfter";
import n from "dayjs/plugin/isSameOrBefore";
e.extend(t), e.extend(n);
function r(t, n, r) {
	return !n && !r || n && r && t && e(t).isSame(n) && e(t).isSame(r) ? !0 : !(n && e(t).isBefore(n) || r && e(t).isAfter(r));
}
var i = (t) => {
	t.startDate && t.endDate && e(t.endDate).isBefore(e(t.startDate)) && (t.endDate = "");
}, a = (e) => e[e.currentDateSelection] || e.currentDateSelection === "endDate" && e.startDate || "", o = (e, t, n) => {
	let { startDate: r } = e, i = t.disableDateBefore, a = t.disableDateAfter;
	return r && n === "endDate" && (i = r), {
		disableDateBefore: i,
		disableDateAfter: a
	};
};
export { r as check_if_in_range, i as clearEndDateIfBeforeStart, a as getSelectionAnchorDate, o as normalizeDisabledDates };

//# sourceMappingURL=index.js.map